export default "__VITE_ASSET__DpTKAaz6__"